import { useMutation, useQuery } from 'react-query'
import { createBookmark, deleteBookmark, getBookmarks } from './bookmarks'
import { Bookmark } from '../types'
import { queryClient } from 'queryClient'

export const METADATA_KEY = '__METADATA__'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function buildTree(data: Record<string, any>) {
  const tree = {}
  Object.entries(data).forEach(([connectionId, bookmarks]) => {
    tree[connectionId] = {}
    bookmarks.forEach((bookmark) => {
      const { fqn } = bookmark
      const path = fqn
        .replace(/`/g, '')
        .split('.')
        .map((partial, i, original) => [...original.slice(0, i), partial].join('.'))

      let currentLevel = tree[connectionId]
      path.forEach((p, i) => {
        const isLast = i === path.length - 1
        if (!currentLevel[p]) {
          currentLevel[p] = {
            [METADATA_KEY]: Object.entries(bookmark.metadata).reduce(
              (acc, [key, value]) => ({ ...acc, [key]: Array.isArray(value) ? value[i] : isLast ? value : undefined }),
              { isLeaf: isLast }
            )
          }
          if (currentLevel[METADATA_KEY]?.isLeaf) {
            currentLevel[METADATA_KEY].isLeaf = false
          }
        }
        currentLevel = currentLevel[p]
      })
    })
  })
  return tree
}

export const useBookmarks = () => {
  const query = useQuery({
    queryKey: ['bookmarks'],
    queryFn: async () => {
      const data = await getBookmarks()
      queryClient.setQueryData(['bookmarks-raw'], data)
      return buildTree(data)
    }
  })

  return {
    ...query,
    raw: queryClient.getQueryData(['bookmarks-raw'])
  }
}

export const useCreateBookmark = () => {
  return useMutation({
    mutationFn: async ({ connectionId, bookmark }: { connectionId: string; bookmark?: Bookmark }) => {
      await createBookmark(connectionId, bookmark)
    }
  })
}

export const useDeleteBookmark = () => {
  return useMutation({
    mutationFn: async ({ connectionId, bookmark }: { connectionId: string; bookmark?: Bookmark }) => {
      await deleteBookmark(connectionId, bookmark)
    }
  })
}
